<template>
  <div>
    <section class="content cleafix" v-if="step === 1">
      <form>
        <h1 class="form-head">
          用户登录
        </h1>
        <div class="form-body">
          <div class="input-item">
            <input type="text" class="input" name="username" placeholder="用户名：邮箱或手机号" required="required" v-model.trim="username" autocomplete="off" @blur="validateUsername()">
            <span class="input-tips">{{error.username}}</span>
          </div>
          <div class="input-item clearfix" v-if="type === 1">
            <div class="col-xs-12 clearfix">
              <div class="row clearfix">
                <div class="col-sm-7 n-p-l">
                  <input type="text" class="input" v-model.trim="verifyCode" placeholder="验证码：6位" @blur="validateCode()">
                </div>
                <div class="col-sm-5 n-p-r n-p-l">
                  <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="code.disabled" @click="sendVerifyCode()">{{code.text}}</button>
                </div>
              </div>
              <div class="row">
                <span class="input-tips">{{error.code}}</span>
              </div>
            </div>
          </div>
          <div class="input-item" v-if="type === 2">
            <input type="password" class="input" name="password" placeholder="密码：6-16位字符、数字、特殊字符" required="required" v-model.trim="password" autocomplete="off" @blur="validatePassword()">
            <span class="input-tips">{{error.password}}</span>
          </div>
          <h5 class="reg-now m-t-b-xs clearfix">
            <span class="right color-default" style="cursor:pointer;" v-if="type === 1" @click="type=2">使用密码登录</span>
            <span class="right color-default" style="cursor:pointer;" v-if="type === 2" @click="type=1">使用验证码登录</span>
          </h5>
          <div class="input-item clearfix">
            <input type="button" class="btn btn-md btn-primary col-xs-12 login-btn" value="登    录" @click="userLogin()">
          </div>
          <h5 class="reg-now m-t-b-sm" v-if="type===2">还没有帐号?
            <router-link :to="{ name: '/auth/register', params: {}}" class="color-primary ">马上注册</router-link>
            <router-link :to="{ name: '/auth/reset_password', params: {}}" class="color-primary right">忘记密码?</router-link>
          </h5>
          <h5 class="reg-now m-t-b-sm" v-if="type===1">&nbsp;</h5>
          <h5 class="third-plat  m-t-b-sm">
            <span>使用其他平台登录</span>
          </h5>
          <div class="third-plats  clearfix">
            <a href="/api/v1/auth/lechenggu" class="third-login-btn">
              <img src="/assets/images/lechenggu.png" alt="">
            </a>
            <a href="/api/v1/auth/weibo" class="third-login-btn">
              <img src="/assets/images/weibo.png" alt="">
            </a>
            <!-- <a href="/api/v1/auth/qq" class="third-login-btn"> -->
          </div>
        </div>
      </form>
    </section>
    <!-- 完善信息 -->
    <section class="content" v-if="step === 2">
      <div class="init-content">
        <div class="step-content">
          <form class="company-info">
            <h1 class="form-head">完善个人信息</h1>
            <div class="input-item m-b">
              <div class="logo">
                <img :alt="user.nickname" :src="user.avatar">
                <input type="file" class="hidden-file" name="file" accept="image/*" @change="uploadAvatar($event)">
              </div>
            </div>
            <div class="input-item show-info text-center">
              <input type="text" class="input" placeholder="用户昵称：乐橙谷" required="required" v-model.trim="user.nickname" autocomplete="off">
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="真实姓名：华宇互联" required="required" v-model.trim="user.realname" autocomplete="off">
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="QQ：10000" required="required" v-model.trim="user.qq" autocomplete="off">
            </div>
            <div class="input-item">
              <textarea class="input textarea" resize="none" placeholder="个性签名：人在江湖飘，就是要挨刀！" required="required" v-model.trim="user.signature" autocomplete="off"></textarea>
            </div>
            <div class="input-item">
              <input type="button" class="btn btn-md btn-primary col-xs-12" value="完善信息" @click="completeInfo()">
            </div>
          </form>
        </div>
      </div>
    </section>
    <!--/ 完善信息 END /-->
  </div>
</template>
<script>
import Auth from "../../resource/auth";
import WebUploader from "webuploader";
// 用户处理
const userHandler = function(v, user) {
  // 未完善信息
  if (user.category === 1 && (!user.realname || !user.nickname)) {
    v.step = 2;
    v.user.realname = user.realname;
    v.user.nickname = user.nickname;
    v.user.qq = user.qq;
    v.user.avatar = user.avatar || "/assets/images/default-user-avatar.png";
    v.user.signature = user.signature;
    v.uploader = WebUploader.create({
      auto: true,
      server: "/api/upload",
      pick: {
        multiple: false
      },
      accept: {
        title: "Images",
        extensions: "gif,jpg,jpeg,bmp,png",
        mimeTypes: "image/*"
      },
      formData: {}
    });
  } else {
    // 跳转
    v.$store.dispatch("getSession");
    v.$router.replace(
      v.$route.query.refer ||
        (user.category === 2 || user.role === 2 || user.role === 3
          ? "/company"
          : "/user")
    );
  }
};
export default {
  data: function() {
    return {
      type: 1, // login type 1: phone ,2 password
      step: 1,
      username: "",
      password: "",
      verifyCode: "",
      code: {
        interval: 60,
        timer: null,
        text: "发送验证码",
        disabled: true
      },
      user: {
        nickname: "",
        realname: "",
        avatar: "/assets/images/default-user-avatar.png",
        qq: "",
        signature: ""
      },
      error: {
        username: "",
        password: "",
        code: ""
      },
      validate: [0, 0],
      uploader: null
    };
  },
  watch: {
    type: function() {
      const that = this;
      that.username = "";
      that.verifyCode = "";
      that.disabled = true;
      that.error.username = "";
      that.error.password = "";
      that.error.code = "";
      that.validate = [0, 0];
    }
  },
  created: function() {
    document.title = `用户登录|${this.global.name}`;
    let that = this;
    that.username = that.$route.query.username;
  },
  methods: {
    validateUsername: function() {
      let that = this;
      that.code.disabled = true;
      if (!that.username) {
        that.validate[0] = 0;
        that.error.username = "请输入用户名后登录";
        return false;
      }
      if (that.global.regex.email.test(that.username)) {
        that.error.username = "";
        that.validate[0] = 1;
        that.code.disabled = false;
        return true;
      } else if (that.global.regex.phone.test(that.username)) {
        that.error.username = "";
        that.validate[0] = 1;
        that.code.disabled = false;
        return true;
      } else {
        that.validate[0] = 0;
        that.error.username = "格式错误：注册邮箱或手机号";
        return false;
      }
    },
    validatePhone: function() {
      let that = this;
      that.code.disabled = true;
      if (!that.username) {
        that.validate[0] = 0;
        that.error.username = "请输入手机号";
        return false;
      }
      if (that.global.regex.phone.test(that.username)) {
        that.error.username = "";
        that.validate[0] = 1;
        that.code.disabled = false;
        return true;
      } else {
        that.validate[0] = 0;
        that.error.username = "请输入正确的手机号";
        return false;
      }
    },
    validatePassword: function() {
      let that = this;
      if (!that.password) {
        that.validate[0] = 0;
        that.error.password = "请输入密码后登录";
        return;
      }
      if (that.global.regex.password.test(that.password)) {
        that.error.password = "";
        that.validate[1] = 1;
      } else {
        that.validate[1] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符";
      }
    },
    validateCode: function() {
      const that = this;
      if (that.verifyCode == "") {
        that.validate[1] = 0;
        that.error.code = "请输入验证码";
        return false;
      }
      if (that.global.regex.code.test(that.verifyCode)) {
        that.error.code = "";
        that.validate[1] = 1;
        return true;
      } else {
        that.validate[1] = 0;
        that.error.code = "请输入正确的验证码";
        return false;
      }
    },
    sendPhoneCode: function() {
      const that = this;
      that.code.disabled = true; // 禁用按钮
      that.$http
        .get(`/api/v1/auth/phone_login_code?phone=${that.username}`)
        .then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.code.seconds = 60;
              that.code.text = `剩余，${that.code.seconds}s`;
              that.code.timer = setInterval(() => {
                // 倒计时
                if (that.code.seconds === 0) {
                  that.code.disabled = false;
                  that.code.text = `发送验证码`;
                  clearInterval(that.code.timer);
                  that.code.timer = null;
                } else {
                  that.code.seconds--;
                  that.code.text = `剩余，${that.code.seconds}s`;
                }
              }, 1000);
            } else {
              that.code.disabled = false;
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试登录(╯﹏╰）!!!");
          }
        });
    },
    sendVerifyCode: function() {
      // 发送验证码
      const that = this;
      that.code.disabled = true; // 禁用按钮
      Auth.sendVerifyCode({ username: that.username }).then(res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            that.code.seconds = 60;
            that.code.text = `剩余，${that.code.seconds}s`;
            that.code.timer = setInterval(() => {
              // 倒计时
              if (that.code.seconds === 0) {
                that.code.disabled = false;
                that.code.text = `发送验证码`;
                clearInterval(that.code.timer);
                that.code.timer = null;
              } else {
                that.code.seconds--;
                that.code.text = `剩余，${that.code.seconds}s`;
              }
            }, 1000);
          } else {
            that.code.disabled = false;
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试登录(╯﹏╰）!!!");
        }
      });
    },
    userLogin: function() {
      const that = this;
      if (that.type === 2) {
        // 密码登录
        that.validateUsername();
        that.validatePassword();
      } else {
        // 手机登录
        that.validateUsername();
        that.validateCode();
      }
      if (that.validate.join("") === "11") {
        if (that.type === 1) {
          // 短信密码登录
          Auth.loginByCode(
            {},
            {
              username: that.username,
              verifyCode: that.verifyCode
            }
          ).then(
            res => {
              let data = res.body;
              if (data.code === 0) {
                // 校验成功
                if (data.result) {
                  userHandler(that, data.result);
                } else {
                  that.error.username = "验证码已失效，请重新获取";
                }
              } else {
                alert(data.msg);
              }
            },
            res => {
              alert(
                "服务器繁忙，请稍后再重试注册(╯﹏╰）!!!\n有人要扣钱了(>﹏<)！！！"
              );
            }
          );
        } else {
          // 短信密码登录
          Auth.loginByPassword(
            {},
            { username: that.username, password: that.password }
          ).then(
            res => {
              let data = res.body;
              if (data.code === 0) {
                // 校验成功
                if (data.result) {
                  userHandler(that, data.result);
                } else {
                  that.error.username = "用户名或密码错误";
                }
              } else {
                alert(data.msg);
              }
            },
            res => {
              alert(
                "服务器繁忙，请稍后再重试注册(╯﹏╰）!!!\n有人要扣钱了(>﹏<)！！！"
              );
            }
          );
        }
      }
    },
    uploadAvatar: function(event) {
      const that = this;
      that.uploader.on("uploadSuccess", (file, res) => {
        if (res.code === 0) {
          that.user.avatar = res.result.url;
        } else {
          alert(res.msg);
        }
      });
      that.uploader.addFile(event.target.files[0]);
    },
    completeInfo: function() {
      const that = this;
      if (!that.global.regex.name.test(that.user.nickname)) {
        alert("昵称格式错误，由字母、汉字及数字组成");
        return false;
      }
      if (!that.global.regex.name.test(that.user.realname)) {
        alert("姓名格式错误，由字母、汉字及数字组成");
        return false;
      }
      that.$http.put("/api/v1/users/", that.user).then(res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            that.$router.replace(
              that.$route.query.refer ||
                (that.user.category === 2 ||
                that.user.role === 2 ||
                that.user.role === 3
                  ? "/company"
                  : "/user")
            );
          } else {
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      });
    }
  }
};
</script>

<style lang="less">
.login-btn {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// login.vue?346a688a